export default __webpack_public_path__ + "static/bienfaits-velo-5dfce8ef37d9063965ec1cf985a4223c.png";